import React, { useState } from 'react';
import { Card, Form, Button, Alert } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { analyticsService } from '../services/analyticsService';

const languages = [
  { code: 'all', label: '🌐 Всем' },
  { code: 'ru', label: 'Русский' },
  { code: 'uk', label: 'Українська' },
  { code: 'es', label: 'Español' },
  { code: 'en', label: 'English' },
];

const BroadcastPage = () => {
  const [message, setMessage] = useState('');
  const [language, setLanguage] = useState('all');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!message.trim()) {
      toast.warn('Введите текст уведомления');
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const { count } = await analyticsService.sendBroadcastNotification({
        message: message.trim(),
        language,
      });
      toast.success(
        count
          ? `Уведомление отправлено ${count} пользователям`
          : 'Уведомление отправлено (список пользователей пуст)',
      );
      setMessage('');
    } catch (e) {
      const msg = e?.response?.data?.message || 'Ошибка при отправке уведомления';
      setError(msg);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <h1 className="mb-3">Массовые уведомления</h1>
      <Card>
        <Card.Body>
          {error && (
            <Alert variant="danger" className="mb-3">
              {error}
            </Alert>
          )}
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Язык рассылки</Form.Label>
              <Form.Select
                value={language}
                onChange={(e) => setLanguage(e.target.value)}
                disabled={loading}
              >
                {languages.map((l) => (
                  <option key={l.code} value={l.code}>
                    {l.label}
                  </option>
                ))}
              </Form.Select>
              <div className="small text-muted">
                {language === 'all'
                  ? 'Уведомление получат все пользователи приложения.'
                  : 'Уведомление получат пользователи с языком профиля, совпадающим с выбранным. Пользователи без указанного языка считаются русскоязычными (ru).'}
              </div>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Текст уведомления для всех пользователей приложения</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Например: Сегодня в 20:00 будет техобслуживание сервиса…"
                disabled={loading}
              />
              <div className="text-muted small mt-1">
                Длина: {message.length} символов
              </div>
            </Form.Group>
            <Button type="submit" variant="primary" disabled={loading}>
              {loading ? 'Отправка…' : 'Отправить всем в приложении'}
            </Button>
          </Form>
        </Card.Body>
      </Card>
    </>
  );
};

export default BroadcastPage;

